import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isDesktopSidebarOpen, setIsDesktopSidebarOpen] = useState(true);
  const [isLargeScreen, setIsLargeScreen] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= 1024 : true
  );

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen((v) => !v);
  };

  const toggleDesktopSidebar = () => {
    setIsDesktopSidebarOpen((v) => !v);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex h-[100dvh] overflow-hidden bg-slate-100 dark:bg-slate-950">
      <Sidebar
        isMobile={isMobileSidebarOpen}
        isDesktopOpen={isDesktopSidebarOpen}
        toggleMobileSidebar={toggleMobileSidebar}
      />

      <div
        className={clsx(
          'flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden transition-[margin] duration-300 ease-out',
          isLargeScreen && isDesktopSidebarOpen ? 'lg:ml-[280px]' : 'lg:ml-0'
        )}
      >
        <Header toggleMobileSidebar={toggleMobileSidebar} toggleDesktopSidebar={toggleDesktopSidebar} />
        <main className="main-scroll flex-1 overflow-y-auto px-4 py-6 md:px-8">
          <div className="mx-auto max-w-[1600px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
